import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import { Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'

function VerCapacitacionEvento(props) {
	const { capacitacion, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver capacitacion" />
			<Offcanvas.Body id="ver-comunicado">
				<h1>Campos de la capacitacion</h1>
				{capacitacion.borrador ? (<Row>
					<Col sm={12} md={6}>
						<Alert variant="warning">Esta capacitación o evento está en modo borrador.</Alert>
					</Col>
				</Row>) : null}
				<Row>
					<Col>
						<label>Título</label>
						<div className="titulo">
							{capacitacion.titulo}
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<label>Slug</label>
						<div className="slug">
							{capacitacion.slug}
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="mb-2">
						<label>Contenido</label>
						<div className="contenido">
							{capacitacion.contenido}
						</div>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col>
						<label>Fecha</label>
							<div className="fecha">
								{capacitacion.fecha.substr(0, 16)}
							</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<label>Imagen</label>
						<div>
							{capacitacion.imagen ? (<img src={process.env.REACT_APP_API_URL + capacitacion.imagen.url} alt=""></img>) : '-'}
						</div>
					</Col>
				</Row>
			</Offcanvas.Body >
		<PanelFooter>
			<Button variant="outline-primary" onClick={handleClose} className="me-2">
				Ok
			</Button>
		</PanelFooter>
		</Offcanvas >
	)
}

export default VerCapacitacionEvento